import * as Yup from 'yup';
import { useFormikContext, connect, FieldArray } from 'formik';
import { Form } from './src/Form';
import { Field } from './src/Field';
import { FieldSet } from './src/FieldSet';
import { Legend } from './src/Legend';
import { AutoSave } from './src/AutoSave';
import { Title } from './src/Title';
import { Context } from './src/Context';

Form.AutoSave = AutoSave;
Form.Field = Field;
Form.FieldSet = FieldSet;
Form.Legend = Legend;
Form.Title = Title;
Form.FieldArray = FieldArray;

Form.Context = Context;

export { Form, Yup, useFormikContext, connect };
